import { render } from "./SongExportTab.vue?vue&type=template&id=07a8e84c&scoped=true"
import script from "./SongExportTab.vue?vue&type=script&lang=js"
export * from "./SongExportTab.vue?vue&type=script&lang=js"

import "./SongExportTab.vue?vue&type=style&index=0&id=07a8e84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a8e84c"]])

export default __exports__